import { Outlet, useLocation } from 'react-router-dom';
import { useEffect, useRef, useState, Suspense } from 'react';
import { Sidebar } from '@components/layout/Sidebar';
import { TopBar } from '@components/layout/TopBar';
import { RouteLoadingFallback } from '@components/ui/Skeleton';

export function DashboardLayout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    mainRef.current?.scrollTo({ top: 0, left: 0 });
  }, [location.pathname]);

  return (
    <div className="fixed inset-0 overflow-hidden bg-background">
      <Sidebar 
        collapsed={isSidebarCollapsed} 
        onCollapsedChange={setIsSidebarCollapsed}
        isMobileOpen={isMobileMenuOpen}
        onMobileClose={() => setIsMobileMenuOpen(false)}
      />

      <div
        className={`flex h-full min-h-0 flex-col overflow-hidden transition-[margin-left] duration-200 ${
          isSidebarCollapsed ? 'md:ml-20' : 'md:ml-64'
        } ml-0`}
      >
        <TopBar 
          onMobileMenuToggle={() => setIsMobileMenuOpen(!isMobileMenuOpen)} 
        />
        <main ref={mainRef} className="min-h-0 flex-1 overflow-y-auto bg-background p-4 md:p-6">
          <Suspense fallback={<RouteLoadingFallback />}>
            <Outlet />
          </Suspense>
        </main>
      </div>
    </div>
  );
}
